import React from 'react';
import { classnames as cx } from '../../utilities';
import './MonthlyPayment.scss';

type OwnProps = {
  hasValidTerms: boolean;
  handleClick: () => void;
};

export default function FinanceButton({
  hasValidTerms,
  handleClick
}: OwnProps): JSX.Element | null {
  return (
    <button
      type="button"
      className={cx('tooltip-cta', { 'default-terms': !hasValidTerms })}
      onClick={handleClick}
    >
      Get Financing
    </button>
  );
}
